'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { JAVASCRIPTS_FETCH, FINDER_FILE_DELETE, FINDER_FILE_RESTORE_DELETED } from 'DesignData/actions/ActionTypes';
import { JS } from 'DesignData/constants/TemplateFileTypes';

const getUpdatedStateData = scripts => {
  const rawData = scripts;
  const byId = {};
  const byPath = {};
  const orderById = new Array(scripts.length);
  scripts.forEach((s, idx) => {
    orderById[idx] = s.id;
    byId[s.id] = byPath[s.path] = s;
  });
  return {
    rawData,
    byId,
    byPath,
    orderById
  };
};
/*
 * Export
 */


export default function javascripts(state = SeamlessImmutable({
  rawData: [],
  byId: {},
  byPath: {},
  orderById: []
}), action) {
  switch (action.type) {
    case JAVASCRIPTS_FETCH:
      {
        const {
          javascripts: scripts
        } = action;

        if (!scripts) {
          return state;
        }

        return state.replace(getUpdatedStateData(scripts), {
          deep: true
        });
      }

    case FINDER_FILE_DELETE:
      {
        if (action.fileType === JS) {
          const {
            rawData
          } = state;
          return state.replace(getUpdatedStateData(rawData.filter(script => script.id !== action.fileId)), {
            deep: true
          });
        }

        return state;
      }

    case FINDER_FILE_RESTORE_DELETED:
      {
        if (action.fileType === JS) {
          const {
            rawData
          } = state;
          return state.replace(getUpdatedStateData([...rawData, action.file]), {
            deep: true
          });
        }

        return state;
      }

    default:
      return state;
  }
}